import styles from './ccf-interaction-search-chat-icon.module.scss';
import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfInteractionSearchChatIconProps {}

/**
 * Component displays CcfInteractionEmailIcon Icon
 * @param props -CcfInteractionEmailIconProps
 * @returns CcfInteractionEmailIcon svg icon
 * @example <CcfInteractionEmailIcon/>
 */
export function CcfInteractionSearchChatIcon(
  props: CcfInteractionSearchChatIconProps
) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3804 5.00003H5.61955C4.13495 4.99479 2.70904 5.58495 1.65527 6.64077C0.601503 7.6966 0.00611787 9.13168 0 10.6306V10.7275C0.00611787 12.2264 0.601503 13.6614 1.65527 14.7173C2.70904 15.7731 4.13495 16.3633 5.61955 16.358H7.91111L12.8169 19.9155C12.894 19.9674 12.9839 19.9965 13.0766 19.9997C13.1692 20.0029 13.2609 19.9799 13.3413 19.9334C13.4134 19.8907 13.4732 19.8299 13.5151 19.757C13.557 19.684 13.5795 19.6013 13.5804 19.517L12.8471 15.7693C13.7884 15.3132 14.5835 14.5986 15.1411 13.7074C15.6987 12.8161 15.9964 11.7843 16 10.7302V10.6333C15.9946 9.13391 15.3995 7.69814 14.3457 6.64173C13.2918 5.58532 11.8655 4.99479 10.3804 5.00003Z"
          fill="#3498db"
        />
        <path
          d="M21.75 8.75C21.75 8.33578 21.4142 8 21 8C20.5858 8 20.25 8.33578 20.25 8.75V12H18.2732C18.0485 12 17.9202 12.2454 18.055 12.4174L20.7819 15.8957C20.8909 16.0348 21.1091 16.0348 21.2182 15.8957L23.945 12.4174C24.0798 12.2454 23.9515 12 23.7268 12H21.75V8.75Z"
          fill="#3498db"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfInteractionSearchChatIcon;
